/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationConfigResponseBaseResponse as ModelsV4ApplicationApplicationConfigResponseBaseResponse } from '../../models/Models/v4/Application/application-config-response-base-response';

export interface V4PublicApplicationConfigGet$Xml$Params {
  publicAccountId?: string;
  dealershipShortcode?: string;
  origin?: string;
}

export function v4PublicApplicationConfigGet$Xml(http: HttpClient, rootUrl: string, params?: V4PublicApplicationConfigGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationConfigResponseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4PublicApplicationConfigGet$Xml.PATH, 'get');
  if (params) {
    rb.query('publicAccountId', params.publicAccountId, {});
    rb.query('dealershipShortcode', params.dealershipShortcode, {});
    rb.query('origin', params.origin, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV4ApplicationApplicationConfigResponseBaseResponse>;
    })
  );
}

v4PublicApplicationConfigGet$Xml.PATH = '/v4/public/application/config';
